var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorClearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3063_14814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99935 15.8333C4.99935 16.75 5.74935 17.5 6.66602 17.5H13.3327C14.2493 17.5 14.9993 16.75 14.9993 15.8333V7.5C14.9993 6.58333 14.2493 5.83333 13.3327 5.83333H6.66602C5.74935 5.83333 4.99935 6.58333 4.99935 7.5V15.8333ZM14.9993 3.33333H12.916L12.3243 2.74167C12.1743 2.59167 11.9577 2.5 11.741 2.5H8.25768C8.04102 2.5 7.82435 2.59167 7.67435 2.74167L7.08268 3.33333H4.99935C4.54102 3.33333 4.16602 3.70833 4.16602 4.16667C4.16602 4.625 4.54102 5 4.99935 5H14.9993C15.4577 5 15.8327 4.625 15.8327 4.16667C15.8327 3.70833 15.4577 3.33333 14.9993 3.33333Z",
    fill: "#2B2D42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3063_14814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorClearIcon);
export default __webpack_public_path__ + "static/media/editor-clear-icon.f8038547edcc69807e99d0f5c10147af.svg";
export { ForwardRef as ReactComponent };